import { render, staticRenderFns } from "./activity-comic_contest.vue?vue&type=template&id=56825e60&scoped=true&"
import script from "./activity-comic_contest.vue?vue&type=script&lang=js&"
export * from "./activity-comic_contest.vue?vue&type=script&lang=js&"
import style0 from "./activity-comic_contest.vue?vue&type=style&index=0&id=56825e60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56825e60",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Atlas: require('/var/jenkins_home/workspace/prod-web-xfans/components/atlas.vue').default})
